/** Chat-capable Workers AI models for persona bots. Ids match env.AI.run(). */
export type BotModelOption = {
  id: string;
  label: string;
  hint?: string;
};

export type BotModelGroup = {
  label: string;
  models: BotModelOption[];
};

export const DEFAULT_BOT_MODEL = "@cf/meta/llama-3.1-8b-instruct-fp8";

export const BOT_MODEL_GROUPS: BotModelGroup[] = [
  {
    label: "Recommended",
    models: [
      { id: "@cf/meta/llama-3.1-8b-instruct-fp8", label: "Llama 3.1 8B Instruct FP8", hint: "Default — fast and cheap" },
      { id: "@cf/meta/llama-3.1-8b-instruct", label: "Llama 3.1 8B Instruct" },
      { id: "@cf/meta/llama-3.2-3b-instruct", label: "Llama 3.2 3B Instruct", hint: "Smaller / quicker" },
      { id: "@cf/meta/llama-3.2-1b-instruct", label: "Llama 3.2 1B Instruct", hint: "Lightest" },
    ],
  },
  {
    label: "Larger / stronger",
    models: [
      { id: "@cf/meta/llama-3.3-70b-instruct-fp8-fast", label: "Llama 3.3 70B Instruct Fast", hint: "Paid plan may apply" },
      { id: "@cf/meta/llama-4-scout-17b-16e-instruct", label: "Llama 4 Scout 17B" },
      { id: "@cf/openai/gpt-oss-20b", label: "GPT-OSS 20B" },
      { id: "@cf/openai/gpt-oss-120b", label: "GPT-OSS 120B", hint: "Paid plan may apply" },
    ],
  },
  {
    label: "Other chat models",
    models: [
      { id: "@cf/qwen/qwen2.5-7b-instruct-fp8", label: "Qwen 2.5 7B Instruct FP8" },
      { id: "@cf/qwen/qwen3-30b-a3b-fp8", label: "Qwen 3 30B-A3B FP8" },
      { id: "@cf/mistral/mistral-7b-instruct-v0.2", label: "Mistral 7B Instruct v0.2" },
      { id: "@cf/meta/llama-3-8b-instruct", label: "Llama 3 8B Instruct" },
    ],
  },
];

export const BOT_MODELS: BotModelOption[] = BOT_MODEL_GROUPS.flatMap((g) => g.models);

const ALLOWED = new Set(BOT_MODELS.map((m) => m.id));

export function isKnownBotModel(id: string): boolean {
  return ALLOWED.has(id);
}

export function resolveBotModel(id: string | null | undefined): string {
  const raw = (id || "").trim();
  if (isKnownBotModel(raw)) return raw;
  return DEFAULT_BOT_MODEL;
}
